import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { objectAsParams } from "../../../helpers/objectToQueryParams";
import Http from "../../../Http";
import Deposito from "./Deposito";
import ACCESS from "../../../ACCESS.js";
// import "../Depositos/Depositos.css";

class Depositos extends TableComponent {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const id_cuenta_bancaria = params.get("id_cuenta_bancaria");
    const fecha_deposito = params.get("fecha_deposito");
    const id_plazo = params.get("id_plazo");
    const id_sucursal = params.get("id_sucursal");
    this.setState({ id_plazo })
    this.tableConfig(
      {
        dataUrl: `pago-deposito/aplicacion/filter?${objectAsParams({
          id_cuenta_bancaria,
          fecha_deposito,
          id_plazo,
          id_sucursal,
        })}`,
        deleteUrl: "deposito/delete",
        deleteField: "cuenta",
        modUrl: "/ApliacionPago/Deposito/",
      },
      TableOp.Table(
        "Depositos",
        [
          { label: "Linea", id: "linea" },
          { label: "Importe", id: "importe" },
          { label: "Timbrado", id: "timbrado" },
          { label: "Cancelada", id: "cancelada" },
          { label: "Cliente", id: "cliente" },
        ],
        [
          { id: "edit", icon: "edit", access: [ACCESS.COBRANZA_APLICACION_PAGOS.EDITAR_DEPOSITO_CONTADO, ACCESS.COBRANZA_APLICACION_PAGOS.EDITAR_DEPOSITO_CREDITO] },
          // { id: 'delete', icon: 'delete' },
        ]
      )
    );
    this.table();
    this.getPago();
  }

  action = (id, row) => {
    if (id === "edit") {
      this.setState({ id_deposito: row.id });
    }
  };

  getPago = async () => {
    const { params } = this.props.match;
    if (params.id) {
      const Res = await Http.get(`pago/one/${params.id}`);
      if (!Res.error) {
        this.setState({ pago: Res.data });
      }
    }
  };

  saveDeposito = async (deposito) => {
    const { id } = this.props.match.params;
    deposito.id_pago = id;
    const Resp = await Http.post(`deposito/save`, deposito);
    if (!Resp.error) {
      this.table();
    }
  };

  render() {
    const { pago, id_deposito, id_plazo } = this.state;
    return (
      <div className="row">
        <div className="col-sm-6">
          {pago && (
            <div className="header">
              <div className="cuenta"> BANORTE 1954</div>
              <div className="dep-field">
                <span className="title">Folio:</span> {pago.folio}
              </div>
              <div className="dep-field">
                <span className="title">Fecha Deposito:</span>{" "}
                {pago.fecha_deposito}
              </div>
              <div className="dep-field">
                <span className="title">Linea de Captura:</span> {pago.linea}
              </div>
            </div>
          )}
          <Deposito id_deposito={id_deposito} id_plazo={id_plazo} />
        </div>
        <div className="col-sm-6">
          <this.TableRender prevUrl />
        </div>
      </div>
    );
  }
}

export default withRouter(Depositos);
